export default __webpack_public_path__ + "static/media/White-LikeIcon.1ea96612.svg";